import { useEffect, useState } from 'react';
import { useOnboarding } from '../../../context/OnboardingContext';
import { logPurchaseCompletedSuccess } from './StripeHelper';
import { getPlanPrice } from '../../../config/plans';
import { trackInitiateCheckout } from '../../../services/analytics';
import { isSandboxEnvironment } from '../../../utils/environment';
import AccordionPanel from './shared/AccordionPanel';

const DEFAULT_PADDLE_CLIENT_TOKEN = 'live_8878df0893b042a9951e8d63c77';

const PaddlePayPal = ({ isExpanded, onSelect }) => {
    const { data, userID, selectedPlan, onboardingId, globalAnswers, urlParams, formData, goToScreenWithName } = useOnboarding();

    const [price, setPrice] = useState(0);


    useEffect(() => {
        console.log("Initialize Paddle");
    }, []);

    const paddleEventHandler = (event) => {

        console.log("[Paddle] event:", event);

        if (event.name == "checkout.payment.initiated") {
            console.log("[Paddle] payment initiated");
            trackInitiateCheckout(formData.get('email') ?? "unknown");
        }

        if (event.name == "checkout.completed") {
            
            console.log("[Paddle] checkout completed");

            const email = formData.get('email') ?? "unknown";

            logPurchaseCompletedSuccess(
                onboardingId, 
                selectedPlan?.priceID, 
                selectedPlan?.discountID, 
                price, 
                urlParams, 
                email
            );    

            goToScreenWithName("final_empty");
        }
    }
    
    const openCheckout = async (paddleItem) => {
        if (typeof window.Paddle === 'undefined') {
            console.warn('Paddle.js not loaded');
            return;
        }

        const countryCode = window.country;

        console.log("Open Paddle checkout", paddleItem, "Country code:", countryCode);

        const isSandbox = isSandboxEnvironment();
        const configuredToken = data?.system?.paddleClientToken;
        // The DEFAULT_PADDLE_CLIENT_TOKEN fallback is a live token, so it must
        // never be used in sandbox - initializing sandbox with a live token
        // would fail. Require an explicitly configured sandbox token instead.
        if (isSandbox && !configuredToken) {
            console.warn('Paddle sandbox is active but no sandbox client token is configured; skipping checkout');
            return;
        }
        const paddleClientToken = configuredToken || DEFAULT_PADDLE_CLIENT_TOKEN;

        // Paddle.js needs the environment set explicitly before Initialize when
        // using a sandbox client token, otherwise it rejects the token.
        if (isSandbox) {
            Paddle.Environment.set("sandbox");
        }
        Paddle.Initialize({ 
            token: paddleClientToken,
            eventCallback: paddleEventHandler
        });

        const email = formData.get('email') ?? null;
        if (!email) {
            goToScreenWithName("email");
            return;
        }
        
        const l = {
            "items": [
                {
                    "priceId": paddleItem.priceId,
                    "quantity": 1
                }
            ],
            "discountId": paddleItem.discountId,
            "customData": {
                "source": "rino",
                "webUserID": userID,
                "email": email,
                "onboardingId": onboardingId,
                "goal": globalAnswers.get('goal')?.value || "unknown",
                "voice": globalAnswers.get('voice')?.value || "unknown",
                "queryParams": urlParams || {}
            },
            "customer": {
                "email": email,
                "address": {
                    "countryCode": countryCode
                }
            },
            "settings": {
                "allowedPaymentMethods": [
                    "paypal"
                ],
                "variant": "multi-page",
                "showAddDiscounts": false,
                "showAddTaxId": true,
                "displayMode": "inline",
                "frameTarget": "paddle-content",
                "frameInitialHeight": 450,
                "frameStyle": "width: 100%; background-color: transparent; border: none;"
            }
        }

        Paddle.Checkout.open(l);
    };

    useEffect(() => {

        console.log("selectedPlan changed paddle", selectedPlan);

        const planPrice = getPlanPrice(selectedPlan?.id);
        const paddleItem = planPrice ? selectedPlan.paddle : null;
        if (planPrice) {
            setPrice(planPrice);
        }

        if (!paddleItem) {
            return
        }

        openCheckout(paddleItem);

    }, [selectedPlan]);


    return (
        <section
            className="item"
            data-state={isExpanded ? 'expanded' : 'collapsed'}
            onClick={onSelect}
        >
            <button type="button" className="trigger" aria-expanded={isExpanded}>
                <div className="radio-circle"></div>
                <div className="payment-icons">
                    <div className="image-wrap svelte-grrljh">
                    <img className="payment-method-icon svelte-171041c" src="/assets/images/coR-ld09.webp" alt="paddle"/>
                    </div>
                </div>
            </button>
            <AccordionPanel expanded={isExpanded}>
                <div className="panel" role="region">
                    <div className="paddle-content">

                    </div>
                </div>
            </AccordionPanel>
        </section>
    );
};

export default PaddlePayPal;

